import React from "react";

import SimpleModal from "./simpleModal";
import CloudMessage from "./cloudMessage";

const ModalUnauthorizeToQuote = ({ open, setOpen }) => {
  const closeModal = async () => {
    setOpen(false);
  };

  return (
    <SimpleModal isOpen={open}>
      <CloudMessage
        className={`modal${open ? " open" : ""}`}
        mainMessage="ACCESO RESTRINGIDO"
        secondaryMessage="Debes iniciar el flujo desde Salesforce."
        onClick={() => closeModal()}
        buttonText="Entendido"
      />
    </SimpleModal>
  );
};

export default ModalUnauthorizeToQuote;
